import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2, ExternalLink } from 'lucide-react';
import { apiService } from '../services/apiService';
import { Button } from '../components/ui/Button';

export const SharedPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const shareId = searchParams.get('share');
    const type = searchParams.get('type');
    const [item, setItem] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (shareId && type) {
            setLoading(true);
            apiService.getSharedItem(type, shareId)
                .then(res => {
                    if (res.success) setItem(res.item);
                    else setError("Item not found");
                })
                .catch(err => {
                    console.error("Failed to load shared item", err);
                    setError("Failed to load item");
                })
                .finally(() => setLoading(false));
        }
    }, [shareId, type]);

    if (loading) return <div className="flex h-screen items-center justify-center"><Loader2 className="animate-spin" /> Loading shared content...</div>;
    if (error) return <div className="flex h-screen items-center justify-center text-red-500">{error}</div>;
    if (!item) return null;

    return (
        <div className="min-h-screen bg-slate-50 p-6 flex flex-col items-center">
            <div className="max-w-4xl w-full bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="bg-primary-600 p-6 text-white flex justify-between items-center">
                    <h1 className="text-xl font-bold flex items-center gap-2"><ExternalLink size={20} /> Shared Listing Studio Result</h1>
                    <Button onClick={() => window.location.href = '/'} variant="secondary">Create Your Own</Button>
                </div>
                <div className="p-8">
                    {item.type === 'listing' ? (
                        <div className="space-y-6">
                            <div className="border-b pb-4">
                                <h2 className="text-2xl font-bold text-slate-900">{item.data.title}</h2>
                                <p className="text-slate-500 mt-2">{item.data.description}</p>
                            </div>
                            <div className="bg-slate-50 p-4 rounded-lg">
                                <h3 className="text-sm font-bold text-slate-500 uppercase mb-2">Tags</h3>
                                <p className="text-slate-700">{item.data.tags}</p>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center">
                            {item.type === 'video' ? (
                                <video src={item.url} controls autoPlay className="w-full max-w-2xl rounded-lg shadow-lg" />
                            ) : (
                                <img src={Array.isArray(item.output) ? item.output[0].url : item.output} alt="Result" className="w-full max-w-2xl rounded-lg shadow-lg" />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
